// convention for constants is
// [App_Name]_[Action]
var ConfigurationConstants: IConfigurationConstants = {
    CONFIGURATION_BEGIN_EDIT: 'CONFIGURATION_BEGIN_EDIT',
    CONFIGURATION_BEGIN_FINISH: 'CONFIGURATION_BEGIN_FINISH',
    CONFIGURATION_UPDATE_EDIT: 'CONFIGURATION_UPDATE_EDIT',
    CONFIGURATION_FINISH_EDIT: 'CONFIGURATION_FINISH_EDIT',
    CONFIGURATION_FORM_TAGDISPLAYDATA: 'CONFIGURATION_FORM_TAGDISPLAYDATA',
    CONFIGURATION_FORM_ATTRIBUTEDATA: 'CONFIGURATION_FORM_ATTRIBUTEDATA',
    CONFIGURATION_FORM_EXTERNALATTRIBUTEDATA: 'CONFIGURATION_FORM_EXTERNALATTRIBUTEDATA',
    CONFIGURATION_FORM_FRIENDCLASSES: 'CONFIGURATION_FORM_FRIENDCLASSES',
    CONFIGURATION_SET_DATA: 'CONFIGURATION_SET_DATA',
    CONFIGURATION_EDIT: 'CONFIGURATION_EDIT',
} as const;

export default ConfigurationConstants;
